// extracted by mini-css-extract-plugin
export default {"root":"dimension-picker_root__18ITB"};